import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { useToggle } from 'usehooks-ts';

export const ApiKeyActionsCell = (props: {
  apiKeyId: number;
  name: string;
  onRevoke: () => void;
}) => {
  const [isRevokeOpen, toggleRevokeOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Revoke', onSelect: toggleRevokeOpen }]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actions-apiKey-${props.apiKeyId}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmColor='error'
        confirmText='Revoke'
        data-testid={`revokeApiKey-${props.apiKeyId}`}
        isOpen={isRevokeOpen}
        message={`Are you sure you want to revoke API key "${props.name}"? This action cannot be undone.`}
        onCancel={toggleRevokeOpen}
        onConfirm={() => {
          toggleRevokeOpen();
          props.onRevoke();
        }}
        title='Revoke API Key'
      />
    </>
  );
};
